// Locale strings of report 2.3 (cash-flow-statement), accountant's document 2026-10-03.
// Merged ONCE into finance.reports2.<camelCaseSlug> by ./index.js: use
// $t("finance.reports2.<camelCaseSlug>.<key>"). Owned by this report only.
export default {
  pageTitle: "Cash Flow Statement (indirect method)",
  title: "Cash Flow Statement (indirect method)",
  item: "Item",
  linkedAccounts: "Linked accounts",
  openingBalance: "Opening balance",
  closingBalance: "Closing balance",
  change: "Change",
  cashEffect: "Cash effect",
  nonCashOffset: "Offset of non-cash items",
  netProfitBeforeTax: "Net profit before tax",
  revenue: "Revenue",
  expenses: "Expenses",
  incomeTax: "Income tax",
  profitAfterTax: "Net profit after tax",
  netChange: "Net change in cash",
  openingCash: "Opening cash",
  closingCash: "Closing cash (computed)",
  actualClosingCash: "Actual cash",
  fxDifference: "Currency translation differences",
  unclassified: "Movements of accounts not classified in the statement",
  controlDifference: "Control difference",
  reconciled: "Matches the actual cash",
  notReconciled: "Does not match the actual cash",
  cashControlTitle: "Final cash control",
  cashControlHint: "The closing cash (boxes + banks + payment gateways) must equal the end of the cash flow statement.",
  baseSummaryTitle: "Base-currency summary",
  rate: "Rate",
  currencySection: "Section in",
  warnings: "Warnings",
  notes: "Notes",
  notesTitle: "Important details",
  alert: "Alert",
  addBack: "Non-cash item (taken out of net profit)",
  missingCodes: "Missing codes",
  unclassifiedHint: "These accounts moved in the period and belong to no statement line:",
  statementSheet: "Cash flows",
  cashSheet: "Cash control",
  summarySheet: "Base currency",
  noAccounts: "No account moved on this line",
  csv: "CSV",
  excel: "Excel",
  periodRequired: "Please choose the start and the end of the period",
};
